<template>
  <div id="active-bundles">
    <div :class="[lang === 'ar' ? 'right-dir' : 'left-dir', 'slider-container']">
      <div style="height: 400px" v-if="load || error">
        <Loader v-if="load" />
        <Error v-if="error" />
      </div>
      <button @click="handleNext" :class="[lang === 'ar' ? 'left rotate' : 'right', 'btn']"> <img src="../../../assets/icons/rightArrow.svg"> </button>
      <button @click="handlePrev" :class="[lang === 'ar' ? 'right' : 'left rotate', 'btn']"> <img src="../../../assets/icons/rightArrow.svg"> </button>
      <carousel :perPage="1"  v-if="!load && !error" :key="componentKey" ref="slider" class="left-dir">
        <slide v-for="(item, i) in items" :key="i" class="right-dir" :class="lang === 'ar' ? 'right-dir' : 'left-dir'">
          <div :id="`item-${i}`" class="content" style="height: 100%;" >
            <div :id="`top-${i}`" class="top">
              <ProfileTopCard @refresh="fetchData($store.state.selectedNumber)" :data="{id:item.id, checked: true, title: item.title, miniTitle: item.price, desc: item.description, type: item.type, startDate: item.startDate, endDate: item.endDate, bundleType: item.bundleType}" />
            </div>
            <div class="hr">
            </div>
            <div :id="`bottom-${i}`" class="bottom">
              <character-card :key="componentKey" :index="i" :data="item.characters" /> <!-- item.characters -->
            </div>
          </div>
        </slide>
      </carousel>
    </div>
  </div>
</template>
<script>
// import VueSlickCarousel from 'vue-slick-carousel-rtl'
// import 'vue-slick-carousel-rtl/dist/vue-slick-carousel-rtl.css'
// import 'vue-slick-carousel-rtl/dist/vue-slick-carousel-theme.css'
import CharacterCard from '../../../components/cards/CharacterCard'
import ProfileTopCard from '../../../components/cards/ProfileTopCard'
import ActiveBundlesRepository from '../../../repositories/ActiveBundlesRepository'
import ConsumptionRepository from '../../../repositories/ConsumptionRepository'
import Loader from '../../../components/LoaderBtn/Loader'
import Error from '../../../components/errorHandle/Error'
import { Carousel, Slide } from 'vue-carousel'
export default {
  components: { Carousel, Slide, CharacterCard, ProfileTopCard, Loader, Error },
  data () {
    return {
      consumeRepo: new ConsumptionRepository(),
      activeBundlesRepo: new ActiveBundlesRepository(),
      lang: this.$lang,
      items: [],
      currentSlide: 0,
      componentKey: 0,
      gsm: this.$store.state.selectedNumber,
      load: false,
      error: false
    }
  },
  mounted () {
    this.$watch(() => {
      return this.$store.state.window
    }, val => {
      this.setHeight()
    })
    this.$watch(() => {
      return this.$store.state.passedNum
    }, val => {
      this.items = []
      this.error = false
      this.load = false
      // this.$refs.slider.$forceUpdate()
      this.fetchData(val)
    })
  },
  watch: {
    load (val) {
      // console.log('load', val)
    }
  },
  created () {
    this.items = []
    this.fetchData(this.gsm)
  },
  methods: {
    handleNext () {
      const currentPage = this.$refs.slider.currentPage
      const nextPage = currentPage + 1
      if (nextPage < this.items.length) {
        this.$refs.slider.goToPage(nextPage)
      }
    },
    handlePrev () {
      const currentPage = this.$refs.slider.currentPage
      const prevPage = currentPage - 1
      if (prevPage >= 0) {
        this.$refs.slider.goToPage(prevPage)
      }
    },
    setHeight () {
      for (let i = 0; i < this.items.length; i++) {
        const topHeight = document.querySelector(`#top-${i}`).clientHeight
        const bottomHeight = document.querySelector(`#bottom-${i}`).clientHeight
        if (topHeight > bottomHeight) {
          document.getElementById(`bottom-${i}`).style.height = `${topHeight}px`
          document.getElementById(`top-${i}`).style.height = `${topHeight}px`
        } else {
          document.getElementById(`top-${i}`).style.height = `${bottomHeight}px`
          document.getElementById(`bottom-${i}`).style.height = `${bottomHeight}px`
        }
        this.$forceUpdate()
      }
    },
    async fetchData (gsm) {
      try {
        this.load = true
        const formData = new FormData()
        formData.append('gsm', gsm)
        const response = await this.activeBundlesRepo.post(formData)
        if (response.status === 200) {
          const temp = [...response.data.data]
          this.items = []
          for (let i = 0; i < temp.length; i++) {
            this.items.push(temp[i])
            await this.fetchConsumption(temp[i].id, temp[i].bundleType, i, gsm)
          }
          // if (this.$store.state.passedNum === gsm) {
          //   this.items = []
          //   for (let i = 0; i < temp.length; i++) {
          //     this.items.push(temp[i])
          //     await this.fetchConsumption(temp[i].id, i, gsm)
          //   }
          //   setTimeout(() => {
          //     this.watchActivePage()
          //   })
          // } else {
          //   return
          // }
          this.error = false
          this.load = false
        } else {
          this.error = true
        }
      } catch (e) {
        this.error = true
        console.log(e)
      }
      this.load = false
      setTimeout(() => {
        this.setHeight()
        this.$refs.slider.$forceUpdate()
      })
    },
    async fetchConsumption (id, bundleType, i, gsm) {
      // console.log(id)
      try {
        const formData = new FormData()
        formData.append('bundleId', id)
        formData.append('bundleType', bundleType)
        formData.append('gsm', gsm)
        const response = await this.consumeRepo.post(formData)
        const temp = { ...response.data.data.details }
        this.items[i].characters = []
        for (const item in temp) {
          if (temp[item]) {
            this.items[i].characters.push({
              type: item,
              consume: temp[item].consumption,
              percent: temp[item].percentage,
              total: temp[item].total
            })
          }
        }
        // if (this.$store.state.passedNum === gsm) {
        //   this.items[i].characters = []
        //   for (const item in temp) {
        //     if (temp[item]) {
        //       this.items[i].characters.push({
        //         type: item,
        //         consume: temp[item].consumption,
        //         percent: temp[item].percentage,
        //         total: temp[item].total
        //       })
        //     }
        //   }
        // }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "src/assets/sass/main";
.rotate {
  transform: rotate(180deg);
}
#active-bundles{
  padding: 1rem 2rem 2rem 3rem;
  box-sizing: border-box;
  height: calc(100vh - (90px + 110px));
  overflow-y: auto;
}
.slider-container{
  background: linear-gradient(45deg, rgba(255,255,255, 0.5), rgb(255,255,255, 0.5));
  border: 3px solid #FFFFFF;
  border-radius: 34px;
  position: relative;
  padding: 1rem 0rem;
  backdrop-filter: brightness(0.9);
  min-height: 400px
}
.btn {
  background: rgba(0,0,0,0.05);
  border-radius: 50%;
  height: 45px;
  width: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  backdrop-filter: blur(25px);
  position: absolute;
  z-index: 10000;
  top: calc(50% - (22.5px));
}
.btn > img {
  width: 10px;
  height: 10px
}
.right {
  right: -22.5px;
}
.left {
  left: -22.5px;
}
.top,
.bottom {
  padding: 0rem 1.5rem;
  //height: 200px
}
.hr {
  width: 100%;
  height: 2px;
  background: rgba(106,106,106,15%);
  margin: 10px 0
}
.content {
  padding: 1rem 0;
}
/*---------- pagination --------------*/
.pagination-container {
  display: flex;
  align-items: center;
  justify-content: center;
  //margin-top: 20px
}
.pagination-el {
  height: 6px;
  width: 6px;
  border-radius: 50%;
  background: rgba(0,0,0, 0.16);
  cursor: pointer;
}
.active {
  background: rgb(0,0,0)
}
/*------------------------------------*/
/*---------------- responsive -----------------*/
@media (max-width: 1200px) {
  #active-bundles {
    //height: auto;
    overflow-y: unset;
    //min-height: calc(100vh - (90px + 110px));
  }
  .top,
  .bottom {
    padding: 0rem 1.5rem;
    //height: 275px
  }
}
@media (max-width: 480px) {
  #active-bundles{
    padding: 1rem 1.3rem 3rem 1rem
  }
  .slider-container {
    padding: .2rem 0
  }
  .top,
  .bottom {
    padding: 0 1rem
  }
}
/*---------------------------------------------*/

</style>
<style lang="scss">
@import "src/assets/sass/main";
#active-bundles {
  .VueCarousel-wrapper,
  .VueCarousel-inner,
  .VueCarousel-slide {
    width: 100%
  }
  .VueCarousel-pagination{
    display: none !important;
    height: 30px;
    //margin-top: calc(-1.5rem - 30px)
  }
  .VueCarousel-dot-container {
    position: unset;
    height: 100%;
    margin-top: 30px !important;
  }
  button.VueCarousel-dot {
    margin: 0;
    width: 8px !important;
    height: 8px !important;
  }
  .vue-simple-select-container .vue-simple-select-option.selected {
    background: none;
    color: $--yellow
  }
}
</style>
